import { Box, Grid } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CommoditiesCard({ result = {} }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  return (
    <Box display={'flex'} flexDirection={'column'} height={'100%'}>
      <Box>
        <Box display={'flex'} sx={{ fontSize: 20, fontWeight: 500 }}>
          <Box sx={{ height: 25, width: 25, mr: 1, overflow: 'hidden' }}>
            <img src="/images/Commodities.png" alt="" />
          </Box>
          {/* LAP-733 (GE022) */}
          <Box>{t('investments.markeet.commodities.title')}</Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray' }}>{t('investments.markeet.commodities.subtitle')}</Box>
        </Box>
      </Box>
      <Box mt={1} height={'100%'}>
        <Grid container spacing={2}>
          {result?.commodity_market?.map((item, index) => (
            <Grid item sm={6} key={index}>
              <Box
                sx={{
                  borderLeft: `5px solid ${item.variantion_1_jour >= 0 ? 'green' : 'red'}`,
                  // mr: 2,
                  pl: '8px',
                  // width: '50%',
                }}
              >
                <Box>{item.name}</Box>
                <Box>
                  {parseFloat(item.price).toFixed(2)} {item.symbol}{' '}
                  <Box component={'span'} color={item.variantion_1_jour >= 0 ? 'green' : 'red'}>
                    {parseFloat(item.variantion_1_jour).toFixed(2)} %
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Box mt={2}>
          {/* LAP-733 (GE022) */}
          <Box sx={{ color: 'gray', fontWeight: 500 }}>{t('investments.markeet.commodities.news')}</Box>
          {result?.news?.map((item, index) => (
            <Box key={index} mt={1}>
              <Box display={'flex'}>
                {item.title}
                <Box component={'samp'} ml={'auto'} color={'gray'}>
                  {moment(item.published_at).fromNow()}
                </Box>
              </Box>
              <Box sx={{ color: 'gray', fontSize: '11px' }}>{item.source}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
